import React from 'react';

import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

export const SportDescriptionsMenu = () => {
  return (
    <Space direction={'horizontal'} size={24} className="h-pt-8 h-pb-8">
      <Typography.Link href={'/sport/bukmekery/'} strong>
        Букмекеры
      </Typography.Link>
      <Typography.Link href={'/sport/stat/'} strong>
        Матч-центр
      </Typography.Link>
      <Typography.Link href={'/enciklopediya/sport/'} strong>
        База знаний
      </Typography.Link>
    </Space>
  );
};

export const SportDescription = () => {
  const isMobile = useIsMobile();

  return (
    <Space direction={'vertical'} size={isMobile ? 8 : 16}>
      <SportDescriptionsMenu />
      <Typography.Text size={14}>
        Регулярно публикуем новости ставок на{'\u00A0'}спорт, интервью спортсменов с{'\u00A0'}их мнениями{'\u00A0'}и
        ожиданиями, котировки букмекеров
      </Typography.Text>
    </Space>
  );
};
